import ErrorPage from "@presentation/components/ErrorPage";
import { useTranslation } from "react-i18next";

const NotFound = (): React.JSX.Element => {
  const { t } = useTranslation();
  return <ErrorPage message={t("error_view.not_found")} />;
};

export default NotFound;
